export function getDomain(host) {
    if (host === undefined) {
        return host;
    }

    const parts = host.split('.');

    if (parts.length === 2) {
        return host;
    }

    parts.shift();

    return parts.join('.');
}

export function getCompanyName() {
  let companyName = 'FairPlay'
  try {
    if (RegExp(/ringo/gi).test(window.location.hostname)) {
      companyName = 'Ringobet'
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(companyName)
  }
  return companyName
}

export function checkIsFlayBet() {
  return RegExp(/fplay.bet/gi).test(window.location.hostname);
}

const hostname = window.location.hostname;

export const isRingo = RegExp(/(ringobet.kz|qa-ringobet.kz)/gi).test(hostname);
export const isRingoKg = RegExp(/(ringo.bet|qa-ringo.bet)/gi).test(hostname);
export const isFpBet = RegExp(/(fp.bet|qa-test.kg)/gi).test(hostname);
export const isUz = RegExp(/(fplay.one|fplay.bet|qa-test.uz)/gi).test(hostname);

export const isStage = RegExp(
  /(qa-ringobet.kz|qa-ringo.bet|qa-test.kg|qa-test.kz|qa-test.uz)/gi
).test(hostname);


// WEBPACK FOOTER //
// ./js/shared/domainUtils.js